import { MILESTONE_STATUS_URL } from './pipelineStatusApi.constants';

/**
 * Real client for the company-scoped pipeline milestone-status endpoint
 * (DEV-3636, Skynet.Loans behind the admin/skynet gateway). The backend scopes
 * the query by the authenticated user's company, so no companyId is passed.
 *
 * Response shape:
 *   { segments: [{ label, count }], asOf, breakdownBySubCompany: [{ subCompanyName, segments }] | null }
 * `breakdownBySubCompany` is owner-only (null for a broker caller).
 */
export class PipelineStatusApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getMilestoneStatus({ config = {} } = {}) {
    return this.#http.get(MILESTONE_STATUS_URL, config);
  }
}
